export interface FlowSpec {
  link: string;
  title: string;
  description: string;
  public?: boolean;
  active?: boolean;
}

export const flows = [
  // {
  //   link: "process-ops",
  //   title: "Unit Operations",
  //   description:
  //     "How do changing my process parameters impact my IPQAs? What could be optimal process parameters? And how do these interact with Formulations?",
  //   public: false,
  // },

  // {
  //   link: "dissolution-profile",
  //   title: "Dissolution Profile",
  //   description:
  //     "How do process parameters, IPQAs and Formulations impact the Dissolution Profile?",
  //   public: false,
  // },
  {
    link: "notebook-analysis",
    title: "Notebook Analysis",
    description:
      "How do changing my process parameters impact my IPQAs? What could be optimal process parameters? And how do these interact with Formulations?",
    public: false,
    active: true,
  },
  {
    link: "sales-effectiveness",
    title: "Salesforce Effectiveness",
    description:
      "What's driving my sales effectiveness? Which kind of leads close and which dont? Can I prioritize my leads for better closure?",
    public: true,
    active: true,
  },
  {
    link: "network-performance-analysis",
    title: "Network Performance Analysis",
    description: "What's driving failures in a telecom network?",
    public: true,
    active: true,
  },
  {
    link: "driver-analysis-binary",
    title: "Driver Analysis (Binary Outcome)",
    description:
      "Define a binary outcome (e.g., churn, failures). And discover why/when that outcome happens. Also clusters where the probabilities of the outcome happening are very different.",
    public: true,
    active: true,
  },
  {
    link: "driver-analysis-continous",
    title: "Driver Analysis (Continous Variable)",
    description:
      "What are the chief drivers for your outcome? And how do they impact the outcome? Are there pockets of data (clusters) where the outcome is very different from the rest?",
    public: true,
    active: true,
  },
  {
    link: "time-series",
    title: "Time Series Analysis",
    description:
      "Everything to do with time-series data. What are the seasonalities? Where are the anomalies? How are time-series related to each other? Are there clusters of time-series?",
    public: true,
    active: true,
  },
  {
    link: "text-mining",
    title: "Text Mining/Analysis",
    description:
      "Discover categories in your data, that you can use to categorize new data as it comes in. Or flag anomalous words as they come, or do a bunch of things with text.",
    public: true,
    active: true,
  },
  {
    link: "impact-analysis-continous",
    title: "Impact Analysis (Continous Outcome)",
    description:
      "What is the impact of a certain action on your (continous) outcome? Are there pockets where impact is higher/lesser?",
    public: true,
    active: true,
  },
  {
    link: "impact-analysis-binary",
    title: "Impact Analysis (Binary Outcome)",
    description:
      "What is the impact of a certain action on your (binary) outcome? Are there pockets where impact is higher/lesser?",
    public: true,
    active: true,
  },
  {
    link: "forecasting",
    title: "Forecasting / Time-Based Driver Analysis",
    description:
      "See drivers for target after first adjusting for time. Auto Periodicity Detection, Correlations, etc.. And what actions can impact the target?",
    public: true,
    active: true,
  },
  {
    link: "profile-discovery",
    title: "Profile Discovery",
    description:
      "Discover profiles at a higher level in any hierarchical data, e.g., profile shopping baskets based on items, profile doctors based on the kind of procedures they do, etc.\n You can also rollup the data at a higher level for use elsewhere.",
    public: true,
    active: true,
  },
  {
    link: "market-mix-modelling",
    title: "Marketing Spend Mix/Attribution",
    description:
      "What's the impact of marketing spend mix? How quickly do marketing spend effects decay? And what will be incremental sales due to fresh marketing spend?",
    public: true,
    active: true,
  },
  {
    link: "clustering",
    title: "Clustering",
    description:
      "Discover clusters in your data, where the each column in the data is an attribute, e.g, cluster customers from profile data (gender, age, income, etc.)",
    public: true,
    active: true,
  },
  {
    link: "eta-estimator",
    title: "ETA Estimator",
    description: "Predict ETA based on origin and destination pairs.",
    public: true,
    active: true,
  },
  {
    link: "basket-analysis",
    title: "Basket Analysis",
    description:
      "Select an ID Column (e.g., transaction ID, machine ID, etc.), and generate patterns where events occur together, e.g., 'what items get bought together?', 'event A happened - how likely is it that event B will happen?', etc.",
    public: true,
    active: false,
  },

  // {
  //   link: "churn-analysis",
  //   title: "Churn and Retention",
  //   description: "What leads to churn? Which users are likely to churn out?",
  //   public: true,
  //   active: false,
  // },

  // {
  //   link: "failure-prediction",
  //   title: "Machine Failure Prediction",
  //   description:
  //     "What's driving machine failures? Which machines are likely to fail in the next week/month",
  //   public: true,
  //   active: false,
  // },
];

export default flows;
